import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import { useToast } from '@/components/base/ToastProvider';
import { submitNotices } from '@/mocks/home';

export default function SubmitSection() {
  const [value, setValue] = useState('');
  const { showToast } = useToast();

  const handleSubmit = () => {
    if (!value.trim()) {
      showToast('请先填写线索来源或链接，再提交给我们核对');
      return;
    }
    showToast('已收到你的线索，我们会核对公开来源后决定是否收录');
    setValue('');
  };

  return (
    <section id="submit" className="scroll-mt-header w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <Reveal>
          <div className="grid grid-cols-1 gap-8 overflow-hidden rounded-lg border border-background-200/70 bg-secondary-50 p-6 md:p-10 lg:grid-cols-12 lg:items-center">
            <div className="lg:col-span-6">
              <div className="flex items-center gap-3">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 font-heading text-xs font-bold text-background-50 dark:text-foreground-950">
                  05
                </span>
                <span className="font-label text-xs font-bold uppercase tracking-[0.2em] text-primary-700">
                  Contribute
                </span>
              </div>
              <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[32px]">
                有线索？投稿给我们核对
              </h2>
              <p className="mt-3 max-w-xl text-sm leading-7 text-foreground-600">
                补充新进展、指出信息滞后，或者提供我们还没收录的话题，都可以提交。核对公开来源后，我们会把它补进对应榜单或合集。
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {submitNotices.map((notice) => (
                  <span
                    key={notice}
                    className="rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-700"
                  >
                    {notice}
                  </span>
                ))}
              </div>
            </div>

            <div className="lg:col-span-6">
              <div className="rounded-lg border border-background-200/70 bg-background-50 p-5 md:p-6">
                <label htmlFor="lead-input" className="text-sm font-semibold text-foreground-900">
                  线索来源链接或简要描述
                </label>
                <div className="mt-3 flex flex-col gap-3 sm:flex-row">
                  <input
                    id="lead-input"
                    type="text"
                    value={value}
                    onChange={(event) => setValue(event.target.value)}
                    placeholder="例如：某品牌公告链接 + 发布时间"
                    className="w-full flex-1 rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-300 focus:outline-none"
                  />
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="inline-flex shrink-0 items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
                  >
                    <i className="ri-send-plane-line flex h-4 w-4 items-center justify-center text-base" />
                    提交线索
                  </button>
                </div>

                <div className="mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-background-200/70 pt-4">
                  <span className="text-xs text-foreground-500">提交内容仅用于来源核对，不会公开展示你的信息。</span>
                  <button
                    type="button"
                    onClick={() => showToast('整理版清单正在生成，稍后可在合集专区查看')}
                    className="inline-flex items-center gap-1.5 rounded-md border border-background-200 px-3.5 py-2 text-xs font-medium whitespace-nowrap text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
                  >
                    <i className="ri-download-2-line flex h-3.5 w-3.5 items-center justify-center text-sm" />
                    下载整理版清单
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}